import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-medical-center',
  templateUrl: './medical-center.component.html',
  styleUrls: ['./medical-center.component.css']
})
export class MedicalCenterComponent implements OnInit {

  constructor(private router: Router,public global: Globals,translate: TranslateService) {
    translate.setDefaultLang('AR');
  }

  ngOnInit() {
  }

}
